var map = {
	"./img_0.png": 760,
	"./img_1.png": 761,
	"./img_10.png": 762,
	"./img_11.png": 763,
	"./img_12.png": 764,
	"./img_13.png": 765,
	"./img_14.png": 766,
	"./img_2.png": 767,
	"./img_3.png": 768,
	"./img_4.png": 769,
	"./img_5.png": 770,
	"./img_6.png": 771,
	"./img_7.png": 772,
	"./img_8.png": 773,
	"./img_9.png": 774
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 759;